export const validateMid = (mid = "") => {
  const regexString = "^CAM-[a-z0-9]{6}\\|TCH-[a-z0-9]{6}\\|TCO-[a-z0-9]{6}\\|CTY-[a-z0-9]{6}\\|CCO-[a-z0-9]{6}\\|PRG-[a-z0-9]{6}$";
  const regex = new RegExp(regexString, "i");
  return regex.test(mid);
};
export const getMidByPriority = ({
  activeMid,
  midFromUrl,
  defaultMid
}) => {
  return midFromUrl || activeMid || defaultMid;
};
